import React, { useEffect, useState } from 'react';
import { ChevronLeft, Moon, Utensils, ActivitySquare, Droplet,Scale , Footprints,AlertTriangle, Loader} from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { fetchUserGoals, fetchUserHabits } from "../../apiservices/ApiService";


const GoalsAndHabits = () => {
  const [activeTab, setActiveTab] = useState('habits');
  const [habits, setHabits] = useState({ current: [], completed: [] });
  const [goals, setGoals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHabits = async () => {
      try {
        const response = await fetchUserGoals()
        const data = response 
        console.log("user/fetch habits API response:", data);
        
          const currentHabits = data.habits.filter(
            (habit) => habit.progressStatus === 'in-progress'
          );
          const completedHabits = data.habits.filter(
            (habit) => habit.progressStatus === 'completed'
          );
          console.log("current:", currentHabits," completed:",completedHabits)
          setHabits({ current: currentHabits, completed: completedHabits });
        
      } catch (error) {
        console.error("Error fetching habits:", error);
      }
    };


    const fetchGoals = async () => {
      try {
          const response = await fetchUserGoals ()
          const data = response 
          console.log("user/fetch goals API response:", data);
          setGoals(data)

      } catch (error) {
        console.error("Error fetching goals:", error);
      }
    };

    const fetchData = async () => {
      setLoading(true);
      await Promise.all([fetchHabits(), fetchGoals()]);
      setLoading(false);
    };

    fetchData();
  }, []);
  const getIcon = (iconType) => {
    switch (iconType) {
      case 'sleep':
        return <Moon size={24} className="text-white" />;
      case 'nutrition':
        return <Utensils size={24} className="text-white" />;
      case 'water':
        return <Droplet size={24} className="text-white" />;
      case 'activity':
        return < Footprints size={24} className="text-white" />;
      case 'weight':
            return <Scale  size={24} className="text-white" />;
      case 'other':
        return < Loader  size={24} className="text-white" />;
     default:
            return <ActivitySquare size={24} className="text-white" />
    }
  };

  const getIconBackground = (iconType) => {
    switch (iconType) {
      case 'sleep':
        return 'bg-primary';
      case 'nutrition':
        return 'bg-danger';
      case 'water':
        return 'bg-info';
      case 'activity':
        return 'bg-warning';
    case 'weight':
            return 'bg-success';
    case 'other':
            return 'bg-warning';
      default:
        return 'bg-secondary';
    }
  };

  if (loading) {
    return <div className="text-center p-4">Loading...</div>;
  }

  return (
    <div className="min-vh-100 bg-light">
      <div className="bg-white py-3 px-4 d-flex align-items-center">
        <ChevronLeft size={24} />
        <h1 className="mx-auto mb-0 h5 text-center">Goals & Habits</h1>
      </div>

      <div className="container mt-4">
        <div className="d-flex gap-3 mb-4">
          <button
            className={`btn w-50 ${activeTab === 'goals' ? 'btn-warning' : 'btn-outline-secondary'}`}
            onClick={() => setActiveTab('goals')}
          >
            My Goals
          </button>
          <button
            className={`btn w-50 ${activeTab === 'habits' ? 'btn-warning' : 'btn-outline-secondary'}`}
            onClick={() => setActiveTab('habits')}
          >
            My Habits
          </button>
        </div>

        {activeTab === 'habits' ? (
          <>
            <h2 className="h6 mb-3">Current Habits</h2>
            {habits.current.map((habit) => (
              <div key={habit.habitId+Math.random()} className="d-flex align-items-center mb-3">
                <div
                  className={`rounded-circle d-flex align-items-center justify-content-center ${getIconBackground(
                    habit.category.toLowerCase()
                  )}`}
                  style={{ width: '48px', height: '48px' }}
                >
                  {getIcon(habit.category.toLowerCase())}
                </div>
                <div className="ms-3">
                  <p className="mb-1 fw-bold">{habit.habitTitle}</p>
                </div>
              </div>
            ))}

            <h2 className="h6 mb-3">Completed Habits</h2>
            {habits.completed.map((habit) => (
              <div key={habit.habitId+Math.random()} className="d-flex align-items-center mb-3">
                <div
                  className={`rounded-circle d-flex align-items-center justify-content-center ${getIconBackground(
                    habit.category.toLowerCase()
                  )}`}
                  style={{ width: '48px', height: '48px' }}
                >
                  {getIcon(habit.category.toLowerCase())}
                </div>
                <div className="ms-3">
                  <p className="mb-1 fw-bold">{habit.habitTitle}</p>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div>
            {goals.map((goal) => (
              <div key={goal.userGoalId+Math.random()} className="bg-white p-3 rounded mb-3 shadow-sm">
                <h3 className="mb-2 h6">{goal.description}</h3>
                <div className="d-flex justify-content-between text-muted small">
                  <span>Start date: {goal.startDate.split(" ")[0]}</span>
                  <span>End date: {goal.endDate.split(" ")[0]}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GoalsAndHabits;
